
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@/store';

interface ActionsUiState {
  viewMode: 'list' | 'grid';
  sortBy: 'name' | 'createdAt' | 'updatedAt';
  sortOrder: 'asc' | 'desc';
  searchQuery: string;
  selectedCategory: string | null;
  showFilters: boolean;
  showAddActionDialog: boolean;
  showCreateFolderModal: boolean;
}

const initialState: ActionsUiState = {
  viewMode: 'grid',
  sortBy: 'createdAt',
  sortOrder: 'desc',
  searchQuery: '',
  selectedCategory: null,
  showFilters: false,
  showAddActionDialog: false,
  showCreateFolderModal: false,
};

const actionsUiSlice = createSlice({
  name: 'actionsUi',
  initialState,
  reducers: {
    setViewMode: (state, action: PayloadAction<'list' | 'grid'>) => {
      state.viewMode = action.payload;
    },
    setSortBy: (state, action: PayloadAction<'name' | 'createdAt' | 'updatedAt'>) => {
      state.sortBy = action.payload;
    },
    setSortOrder: (state, action: PayloadAction<'asc' | 'desc'>) => {
      state.sortOrder = action.payload;
    },
    setSearchQuery: (state, action: PayloadAction<string>) => {
      state.searchQuery = action.payload;
    },
    setSelectedCategory: (state, action: PayloadAction<string | null>) => {
      state.selectedCategory = action.payload;
    },
    setShowFilters: (state, action: PayloadAction<boolean>) => {
      state.showFilters = action.payload;
    },
    setShowAddActionDialog: (state, action: PayloadAction<boolean>) => {
      state.showAddActionDialog = action.payload;
    },
    setShowCreateFolderModal: (state, action: PayloadAction<boolean>) => {
      state.showCreateFolderModal = action.payload;
    },
  },
});

export const {
  setViewMode,
  setSortBy,
  setSortOrder,
  setSearchQuery,
  setSelectedCategory,
  setShowFilters,
  setShowAddActionDialog,
  setShowCreateFolderModal,
} = actionsUiSlice.actions;

// Selectors
export const selectShowAddActionDialog = (state: RootState) => state.actionsUi.showAddActionDialog;
export const selectShowCreateFolderModal = (state: RootState) => state.actionsUi.showCreateFolderModal;

export default actionsUiSlice.reducer;
